import { createTheme } from '@mui/material';
// Pulls @mui/x-date-pickers' component keys (MuiDateTimePicker, etc.) into
// the theme.components type map so default-props below are type-checked.
import type {} from '@mui/x-date-pickers/themeAugmentation';

export const theme = createTheme({
  colorSchemes: {
    dark: {
      palette: {
        mode: 'dark',
        primary: { main: '#b39ddb' },
        secondary: { main: '#ffb199' },
        background: {
          default: '#0f1013',
          paper: '#17181c',
        },
      },
    },
    light: {
      palette: {
        mode: 'light',
        primary: { main: '#6a4caf' },
        secondary: { main: '#d97757' },
      },
    },
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 600, letterSpacing: '-0.02em' },
    h2: { fontWeight: 600, letterSpacing: '-0.02em' },
    h3: { fontWeight: 600, letterSpacing: '-0.01em' },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: 'none', fontWeight: 500 } },
    },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiDateTimePicker: { defaultProps: { ampm: false, format: 'DD/MM/YYYY HH:mm' } },
    MuiDatePicker: { defaultProps: { format: 'DD/MM/YYYY' } },
    MuiTimePicker: { defaultProps: { ampm: false, format: 'HH:mm' } },
  },
});
